import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SidenavService } from "../sidenav.service";

@Component({
    selector: 'app-sidebarbutton',
    templateUrl: './sidebarbutton.component.html',
    styleUrls: ['./sidebarbutton.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SidebarbuttonComponent implements OnInit {

  isVisible = false;
  constructor(readonly sidenavService: SidenavService) { }

  ngOnInit(): void {}

  toggleButton() {
    this.isVisible = !this.isVisible;
    this.sidenavService.toggle();
  }
}
